import BookingSummary from './booking-components/booking-summary'
import ConfirmBooking from './booking-components/confirm-booking'
import Contact from './booking-components/contact'
import Extras from './booking-components/extras'
import Notes from './booking-components/notes'
import Payment from './booking-components/payment'
import PromotionalCode from './booking-components/promotional-code'
import { validate } from './validator'

class Booking {
    constructor(bookingInfoForm, extrasForm, confirmBooking, paymentForm, bookingNo, bookingSummary) {
        this.contact = new Contact(bookingInfoForm, bookingNo)
        this.extras = new Extras(extrasForm, bookingNo, bookingSummary)
        this.summary = new BookingSummary(bookingSummary, bookingNo, this.extras)
        this.notes = new Notes(bookingInfoForm)
        this.payment = new Payment(paymentForm, this.contact)
        this.confirmBooking = new ConfirmBooking(confirmBooking, bookingNo)

        this.stageArray = [this.contact, this.notes, this.extras, this.confirmBooking, this.payment]
    }

    async updateBookingStage(index, next = false) {
        let promises = [];
        
        // Collect all the promises from each stage update
        this.stageArray.forEach(stage => {
            let stagePromises = []
            if (next) {
                stagePromises = stage.onLoad(index + 1);
            }
            else {
                stagePromises = stage.update(index);
            }

            if (stagePromises && Array.isArray(stagePromises) && stagePromises.length > 0) {
                promises = promises.concat(stagePromises);
            }
        });
        
        // Using Promise.allSettled to ensure all promises are executed even if some fail
        const results = await Promise.allSettled(promises);
        
        let status = true
        results.forEach((result, idx) => {
            if (result.status !== 'fulfilled') {
                status = false
            }
        });

        return status
    }
    
    async updateNextBookingStage(index) {
        return this.updateBookingStage(index, true)
    }

    validateFields(currentState) {
        return validate(this.stageArray, currentState)
    }
}

export default Booking
